import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8a581342")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 新增 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 新增 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

import { ref, reactive, onBeforeMount } from 'vue'
import Editor from '@/components/common/Editor/Editor.vue'
import { getSortList, editAppreciation, createAppreciation } from '@/services/appreciation'
import { message } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import MultiSongConfig from '@/components/song/MultiSongConfig.vue'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue'


export default {
  props: {
  current: {
    type: Object,
    default: () => { return {} }
  },
  readOnly: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props
const router = useRouter()

const goBack = () => {
  router.go(-1)
}



const labelCol = { span: 4 }
const wrapperCol = { span: 17 }
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 20
    }
  }
}
const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 20,
      offset: 4
    }
  }
}

const formRef = ref()
const editorRef = ref()

const formState = reactive({
  ...props.current,
  category_ids: props.current.categories && props.current.categories.length > 0
    ? props.current.categories.map(i => i.id) : [undefined],
  lyricists: props.current.lyricists ?? [''],
  composers: props.current.composers ?? ['']
})

const pageState = reactive({
  sortOpts: [],
  nodeList: []
})

const getSortData = async () => {
  const { items } = await getSortList()
  pageState.nodeList = items
  pageState.sortOpts = getTreeData(0, items)
  formState.category_ids = formState.category_ids.map(i => {
    return getNodeFullPath(i)
  })
  formState.category_id = getNodeFullPath(formState.category_id)
}

// 获取节点路径
const getNodeFullPath = (id, path = []) => {
  if (path.length === 0) {
    path.push(id)
  }
  const node = pageState.nodeList.filter(i => id === i.id)[0] ?? {}
  if (node.pid > 0) {
    path.unshift(node.pid)
    return getNodeFullPath(node.pid, path)
  }
  return path
}

// 构造菜单树数据
const getTreeData = (pid, menus) =>
  menus
    .filter(item => item.pid === pid)
    .map(item => {
      if (menus.filter(menu => menu.pid === item.id).length === 0) {
        return { label: item.name, value: item.id }
      }
      return {
        label: item.name,
        value: item.id,
        children: getTreeData(item.id, menus)
      }
    })

const handleUpdateList = info => {
  formState.resources = info
}

const handleSave = async () => {
  await formRef.value.validate()
  const categoryIds = formState.category_ids.map(i => i[i.length - 1]).filter(i => i)
  console.log(categoryIds)
  if (categoryIds.length === 0) {
    message.error('请选择分类')
    return
  }

  try {
    const params = {}
    // params.category_id = formState.category_id.at(-1)
    // params.category_ids = formState.category_ids.map(i => i.at(-1))
    params.category_id = formState.category_id[formState.category_id.length - 1]
    params.category_ids = formState.category_ids.map(i => i[i.length - 1])
    params.intros = editorRef.value.getContent()
    params.song_name = formState.song_name
    params.song_code = formState.song_code
    params.lyricists = formState.lyricists
    params.composers = formState.composers
    params.sub_name = formState.sub_name
    params.resources = formState.resources?.map(i => {
      delete i?.id
      delete i?.famous_music_song_id
      return i
    }) || []
    if (formState.id) {
      await editAppreciation(formState.id, params)
    } else {
      await createAppreciation(params)
    }
    message.success('保存成功')
    goBack()
  } catch (e) {
    console.error(e)
  }
}

const removeItem = (key = 'lyricists', item) => {
  const index = formState[key].indexOf(item)

  console.log(index, formState[key])
  if (index === 0 && formState[key].length === 1) {
    formState[key] = ['']
  } else {
    formState[key].splice(index, 1)
  }
}

const addItem = (key = 'lyricists') => {
  formState[key].push('')
}

onBeforeMount(() => {
  getSortData()
})


return (_ctx, _cache) => {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_cascader = _resolveComponent("a-cascader")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")

  return (_openBlock(), _createBlock(_component_a_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 24,
        xl: 24
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: (_value, _refs) => {
              _refs['formRef'] = _value
              formRef.value = _value
            },
            model: _unref(formState),
            labelCol: labelCol,
            wrapperCol: wrapperCol
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "song_name",
                label: "歌曲名称",
                rules: [{ required: true, message: '请输入歌曲名称' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _unref(formState).song_name,
                    "onUpdate:value": _cache[0] || (_cache[0] = $event => (_unref(formState).song_name = $event)),
                    disabled: props.readOnly
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "song_code",
                label: "歌曲编码"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _unref(formState).song_code,
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => (_unref(formState).song_code = $event)),
                    disabled: props.readOnly
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formState).lyricists, (item, index) => {
                return (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({ key: index }, index === 0 ? formItemLayout : formItemLayoutWithOutLabel, {
                  label: index === 0 ? '作词' : '',
                  name: ['lyricists', index]
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _unref(formState).lyricists[index],
                      "onUpdate:value": $event => (_unref(formState).lyricists[index] = $event),
                      placeholder: "请输入作词家",
                      style: {"width":"60%","margin-right":"8px"},
                      disabled: props.readOnly
                    }, null, 8, ["value", "onUpdate:value", "disabled"]),
                    (!props.readOnly)
                      ? (_openBlock(), _createBlock(_unref(MinusCircleOutlined), {
                          key: 0,
                          class: "dynamic-delete-button",
                          onClick: $event => (removeItem('lyricists', item))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1040, ["label", "name"]))
              }), 128)),
              (!props.readOnly)
                ? (_openBlock(), _createBlock(_component_a_form_item, _normalizeProps(_mergeProps({ key: 0 }, formItemLayoutWithOutLabel)), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "dashed",
                        style: {"width":"60%"},
                        onClick: _cache[2] || (_cache[2] = $event => (addItem('lyricists')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PlusOutlined)),
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 16))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formState).composers, (item, index) => {
                return (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({ key: index }, index === 0 ? formItemLayout : formItemLayoutWithOutLabel, {
                  label: index === 0 ? '作曲' : '',
                  name: ['composers', index]
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _unref(formState).composers[index],
                      "onUpdate:value": $event => (_unref(formState).composers[index] = $event),
                      placeholder: "请输入作曲家",
                      style: {"width":"60%","margin-right":"8px"},
                      disabled: props.readOnly
                    }, null, 8, ["value", "onUpdate:value", "disabled"]),
                    (!props.readOnly)
                      ? (_openBlock(), _createBlock(_unref(MinusCircleOutlined), {
                          key: 0,
                          class: "dynamic-delete-button",
                          onClick: $event => (removeItem('composers', item))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1040, ["label", "name"]))
              }), 128)),
              (!props.readOnly)
                ? (_openBlock(), _createBlock(_component_a_form_item, _normalizeProps(_mergeProps({ key: 1 }, formItemLayoutWithOutLabel)), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "dashed",
                        style: {"width":"60%"},
                        onClick: _cache[3] || (_cache[3] = $event => (addItem('composers')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PlusOutlined)),
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 16))
                : _createCommentVNode("", true),
              _createVNode(_component_a_form_item, {
                name: "sub_name",
                label: "副标题"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _unref(formState).sub_name,
                    "onUpdate:value": _cache[4] || (_cache[4] = $event => (_unref(formState).sub_name = $event)),
                    disabled: props.readOnly
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formState).category_ids, (item, index) => {
                return (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                  class: "form-item",
                  key: index
                }, index === 0 ? {} : {
            wrapperCol: {
                xs: {
                  span: 24,
                  offset: 0
                },
                sm: {
                  span: 17,
                  offset: 4
                }
              }
            }, {
                  label: index === 0 ? '选择分类' : '',
                  name: ['category_ids', index],
                  rules: [{ required: true, message: '请选择分类' }]
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_cascader, {
                      disabled: props.readOnly,
                      "change-on-select": "",
                      value: _unref(formState).category_ids[index],
                      "onUpdate:value": $event => (_unref(formState).category_ids[index] = $event),
                      options: _unref(pageState).sortOpts,
                      placeholder: "请选择分类",
                      expandTrigger: "hover"
                    }, null, 8, ["disabled", "value", "onUpdate:value", "options"]),
                    (!props.readOnly && _unref(formState).category_ids.length > 1)
                      ? (_openBlock(), _createBlock(_unref(MinusCircleOutlined), {
                          key: 0,
                          class: "dynamic-delete-button form-item-minus",
                          onClick: $event => (removeItem('category_ids', item))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1040, ["label", "name"]))
              }), 128)),
              (!props.readOnly)
                ? (_openBlock(), _createBlock(_component_a_form_item, _normalizeProps(_mergeProps({ key: 2 }, formItemLayoutWithOutLabel)), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "dashed",
                        style: {"width":"85%"},
                        onClick: _cache[5] || (_cache[5] = $event => (addItem('category_ids')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PlusOutlined)),
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 16))
                : _createCommentVNode("", true),
              _createVNode(_component_a_form_item, { label: "歌曲配置" }, {
                default: _withCtx(() => [
                  _createVNode(MultiSongConfig, {
                    onUpdateList: handleUpdateList,
                    formIsEdit: !props.readOnly,
                    list: _unref(formState).resources,
                    aliasConfig: {
              url: 'file_url',
              name: 'file_name',
              md5: 'file_md5',
              size: 'file_size'
            }
                  }, null, 8, ["formIsEdit", "list"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "intros",
                label: "简介",
                rules: [{ required: false, message: '请输入简介' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(Editor, {
                    ref: (_value, _refs) => {
                      _refs['editorRef'] = _value
                      editorRef.value = _value
                    },
                    content: _unref(formState).intros,
                    readOnly: props.readOnly
                  }, null, 8, ["content", "readOnly"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }),
      (!props.readOnly)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            offset: 11,
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: handleSave
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

}